import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const webPeduliOptions = [
  { label: "Peduli Sumatera", value: "sumatera" },
  { label: "Peduli Lansia", value: "lansia" },
  { label: "Peduli Yatim", value: "yatim" },
  { label: "Peduli Palestina", value: "palestina" },
  { label: "Peduli Sudan", value: "sudan" },
];

const TambahVideo = () => {
  const [judul, setJudul] = useState("");
  const [webPeduli, setWebPeduli] = useState("");
  const [video, setVideo] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("web_peduli", webPeduli);
    if (video) formData.append("video", video);

    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token="))
      ?.split("=")[1];

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/video`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Video berhasil ditambahkan");
      navigate("/dashboard/video");
    } catch (err) {
      console.error(err);
      alert("Gagal menambahkan video");
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = judul && webPeduli && video;

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-white rounded shadow">
      <Link to="/dashboard/video">
        <div className="flex items-center gap-3 mb-4 text-orange-600">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Tambah Video</h1>
        </div>
      </Link>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Judul */}
        <div>
          <label className="font-semibold">Judul</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={judul} onChange={(e) => setJudul(e.target.value)} />
        </div>

        {/* Web Peduli */}
        <div>
          <label className="font-semibold">Web Peduli</label>
          <select className="w-full border px-3 py-2 rounded bg-white" value={webPeduli} onChange={(e) => setWebPeduli(e.target.value)}>
            <option value="">-- Pilih Web Peduli --</option>
            {webPeduliOptions.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        {/* Video */}
        <div>
          <label className="font-semibold">Video</label>
          <input type="file" accept="video/*" className="w-full border px-3 py-2 rounded bg-white" onChange={(e) => setVideo(e.target.files?.[0] || null)} />
        </div>

        {/* Submit */}
        <button type="submit" disabled={!isFormValid || loading} className={`w-full py-2 rounded text-white ${isFormValid ? "bg-orange-600 hover:bg-orange-700" : "bg-gray-400 cursor-not-allowed"}`}>
          {loading ? "Mengirim..." : "Tambah Video"}
        </button>
      </form>
    </div>
  );
};

export default TambahVideo;
